module.exports = __webpack_public_path__ + "img/education1.6a1971d5.png";